import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Icon, Menu as BaseMenu } from 'antd';

import Security from '../../helpers/security';
import { ReactComponent as USA } from '../../assets/flags/usa.svg';
import { ReactComponent as Spain } from '../../assets/flags/spain.svg';

const UserMenu = ({ user, t, i18n, set }) => {
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const newUserData = user.getData();
    setUserData(newUserData);
  }, [user]);
  if (user.requiresLogin() || !userData) { return <></>; }

  const Flag = () => {
    switch (i18n.language) {
      case 'es':
        return <Icon component={Spain} />;
      case 'en':
      default:
        return <Icon component={USA} />;
    }
  };

  const { picture, name } = userData;
  return (
    <BaseMenu.SubMenu
      style={{ float: 'right' }}
      title={(
        <span className="submenu-title-wrapper">
          <Avatar src={picture} style={{ marginRight: '5px' }} /> <span className="menu-label">{name}</span>
        </span>
      )}
    >
      <BaseMenu.Item
        key="user-key"
        onClick={() => {
          set('keyAdderVisible', true);
        }}
      >
        <Icon type="key" /> {t('header.add_private_key')}
      </BaseMenu.Item>
      <BaseMenu.SubMenu
        title={(
          <>
            <Flag /> {t('header.language')}
          </>
        )}
        onClick={(event) => i18n.changeLanguage(event.key)}
      >
        <BaseMenu.Item key="en">
          <Icon component={USA} /> {t('header.lang.en')}
        </BaseMenu.Item>
        <BaseMenu.Item key="es">
          <Icon component={Spain} /> {t('header.lang.es')}
        </BaseMenu.Item>
      </BaseMenu.SubMenu>
      <BaseMenu.Item
        key="user-logout"
        onClick={() => {
          Security.logout();
          window.location = '/';
        }}
      >
        <Icon type="logout" /> {t('header.signout')}
      </BaseMenu.Item>
    </BaseMenu.SubMenu>
  );
};

UserMenu.propTypes = {
  i18n: PropTypes.shape({
    changeLanguage: PropTypes.func,
    language: PropTypes.string,
  }),
  set: PropTypes.func,
  t: PropTypes.func,
  user: PropTypes.shape({
    getData: PropTypes.func,
    requiresLogin: PropTypes.func,
  }),
};

export default UserMenu;
